import React from 'react';

const Tag = ({ item, cl }) => {
  return <div className={cl('tag')}>{item}</div>;
};

export default Tag;
